type CapacitySort = "ALPHABETICAL" | "ROLE" | "CREATION_DATE" | "TYPE";

const capacitySort: CapacitySort = "TYPE";

export type { CapacitySort };

export { capacitySort };
